'use client';

import { useQuery } from '@tanstack/react-query';
import { fetchFBT } from '../api';

type QueryFBTProps = {
    productId: string;
    customerId: string;
    storeId?: string;
    isEnabled: boolean;
};

export const useQueryFBT = ({
    productId,
    storeId,
    customerId,
    isEnabled,
}: QueryFBTProps) => {
    const queryKey = ['fbt', productId, storeId];

    const { data, error, isSuccess } = useQuery({
        queryKey,
        queryFn: () => fetchFBT({ productId, storeId, customerId }),
        enabled: isEnabled,
        // staleTime – keep cache 1 hour - data is considered fresh for 1 hour,
        // and during this period, reusing the cache will not fetch new data.
        staleTime: 60 * 60 * 1000,
    });

    return { fbtProducts: data, error, isSuccess };
};
